import React from 'react';
import { DndProvider } from 'react-dnd';
import { StyleSheetManager } from 'styled-components';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { FrameContextConsumer } from 'react-frame-component';

export const TextEditorContext = React.createContext();

const FrameBindingContext = ({ children }) => (
    <FrameContextConsumer>
        {({ window, document }) => (
            <DndProvider backend={HTML5Backend} context={window}>
                {/* ! the documentation says `StyleSheetManager` should not be used in client-side */}
                <StyleSheetManager target={document.head}>
                    <TextEditorContext.Provider value={{ document, window }}>
                        {children}
                    </TextEditorContext.Provider>
                </StyleSheetManager>
            </DndProvider>
        )}
    </FrameContextConsumer>
);

export default FrameBindingContext;
